import type { GeneratedInsight } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { Text } from "@amzn/storm-ui";

export function getGeneratedInsightNotification(
    insight: GeneratedInsight,
): JSX.Element {
    const name =
        insight.title ??
        (insight.metadata && insight.metadata["name"]) ??
        "n/a";
    const subtitle = insight.template ?? "";
    return (
        <div style={{ minWidth: 200 }}>
            <Text>{name}</Text>
            {subtitle && <Text size="xsmall">{subtitle}</Text>}
        </div>
    );
}
